export default "__VITE_ASSET__JenY_qK9__"